export const errorsWithPrefix = (errors, prefix) => {
    return Object.keys(errors)
        .filter(v => v.startsWith(prefix))
        .reduce((a, v) => ({ ...a, [v.substring(prefix.length + 1)]: errors[v] }), {});
};

